module.exports = __webpack_public_path__ + "static/eco-db4b52558df7e687459c1f6932732c8e.png";